// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1LinkedWorkItemResourceSchema } from './v1/linkedWorkItemResourceSchema';
import { v1LinkedWorkItemsCreateSchema } from './v1/linkedWorkItems/createSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const createLinkedWorkItemPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const createLinkedWorkItemHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Linked work item created successfully
 */
export const createLinkedWorkItem201Schema = z.lazy(() => v1LinkedWorkItemResourceSchema);

/**
 * @description Unauthorized
 */
export const createLinkedWorkItem401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Forbidden - api_linked_work feature not enabled
 */
export const createLinkedWorkItem403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Validation failed - missing external_id
 */
export const createLinkedWorkItem422Schema = z.lazy(() => v1ValidationErrorSchema);

export const createLinkedWorkItemMutationRequestSchema = z.lazy(() => v1LinkedWorkItemsCreateSchema);

export const createLinkedWorkItemMutationResponseSchema = z.lazy(() => createLinkedWorkItem201Schema);
